import { LoadingSpinner } from "@bluefalcon/components-package";
import { Permission, PermissionCreateRequest, PermissionUpdateRequest } from "@bluefalcon/users-management-client-fetch";
import { Box, Button, Flex, Table, TableCaption, Tbody, Td, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { iamService } from "../../services";
import { AddEditIAMModal } from "../../modals/create-iam.modal";

type PermissionsTableProps = {};

export const PermissionsTable = ({ }: PermissionsTableProps) => {

    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedPermission, setSelectedPermission] = useState<Permission | undefined>(undefined);

    const fetchPermissions = async () => {
        setIsLoading(true);
        const permissions = await iamService.searchPermissions({});
        setPermissions(permissions);
        setIsLoading(false);
    };

    useEffect(() => {
        fetchPermissions();
    }, []);


    const fetchPermssions = async () => {
        const perms = await iamService.searchPermissions({});
        setPermissions(perms);
    };

    useEffect(() => {
        fetchPermissions();
        fetchPermssions();
    }, []);

    const onCreatePermission = async (req: PermissionCreateRequest) => {
        await iamService.createPermission({ ...req });
        fetchPermissions();
        onClose();
    };

    const onUpdatePermission = async (id: number, req: PermissionUpdateRequest) => {
        await iamService.updatePermissionById(id, { ...req });
        fetchPermissions();
        onClose();
    };

    const handleEditButtonClick = (permission: Permission) => {
        setSelectedPermission(permission);
        onOpen();
    };

    const handleAddButtonClick = () => {
        setSelectedPermission(undefined);
        onOpen();
    };

    if (!isLoading && permissions.length === 0) {
        return (
            <Box textAlign={'center'} mt={4}>
                No permissions found.
            </Box>
        )
    }

    if (isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>
            <Flex>
                <Button onClick={handleAddButtonClick} ml={'auto'} colorScheme="teal">Add Permission</Button>
            </Flex>
            <Table variant="simple">
                <TableCaption textAlign={'left'}>Total Permissions: {permissions.length}</TableCaption>
                <Thead>
                    <Tr>
                        <Th>ID</Th>
                        <Th>Name</Th>
                        <Th>Description</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {permissions.map((permission) => (
                        <Tr key={permission.id}>
                            <Td>{permission.id}</Td>
                            <Td>{permission.name}</Td>
                            <Td>{permission.description}</Td>
                            <Td>
                                <Button mr={2} size="sm" onClick={() => handleEditButtonClick(permission)}>
                                    Edit
                                </Button>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
                <AddEditIAMModal
                    entity="Permission"
                    isOpen={isOpen}
                    onClose={onClose}
                    onCreate={onCreatePermission}
                    onUpdate={onUpdatePermission}
                    iam={selectedPermission}
                />
            </Table>
        </>
    )
};
